import config from '../config.js';

/** The sessionStorage keys a session sets (OAuthPage), cleared on sign out. */
export const SESSION_KEYS = ['jwt', 'ProfileImageURL', 'userId', 'theme'];

/**
 * Signs the listener out (ENG-723): revokes the session on the server
 * (`POST /auth/logout`), then clears it here and goes to the login page. The
 * session is cleared even when the server can't be reached: a sign out the
 * listener asked for must not leave them signed in on this device.
 */
export const signOut = async (fetchWrapper, { navigate = (to) => { window.location.href = to; } } = {}) => {
  try {
    await fetchWrapper.post(`${config.apiBaseUrl}/auth/logout`, {});
  } catch (_err) {
    // Cleared below either way.
  }
  SESSION_KEYS.forEach((key) => sessionStorage.removeItem(key));
  navigate('/login');
};
